import React from 'react';
import { connect } from 'react-redux';
import AccessRoute from './AccessRoute';
import { canEditCurriculum } from '../../constants/userRoles';

function CurriculumEditorRoute({ component: Component, userRole, administrativePosition, ...rest }) {
    return (
        <AccessRoute
            condition={canEditCurriculum(userRole, administrativePosition)}
            component={Component}
            {...rest}
        />
    );
}

const mapStateToProps = (state) => ({
    userRole: state.auth.role,
    administrativePosition: state.auth.administrativePosition,
});

export default connect(mapStateToProps)(CurriculumEditorRoute);
